import { BRAND_NAME_FULL, language } from "@chef/constants";

export const intl = (
  {
    no: {
      UNSUBSCRIBE_FROM_SMS: "Avmeld SMS",
      NO_LONGER_INTERESTED: "Ikke interessert i SMS lenger?",
      TYPE_IN_YOUR_PHONE_NUMBER: `Skriv inn telefonnummeret du har registrert hos ${BRAND_NAME_FULL} for å avregistrere deg fra fremtidige SMS-utsendelser.`,
      CONFIRM_UNSUBSCRIPTION: "Bekreft avmelding",
      YOU_ARE_NOW_UNSUBSCRIBED:
        "Du er nå avmeldt fra SMS. Merk at det kan ta et par dager før endringen trer i kraft.",
      YOU_WILL_STILL_RECEIVE_SMS_ABOUT_DELIVERIES:
        "Du vil fortsatt motta SMS med leveringsinformasjon og påminnelser i forkant av ordregenerering. Ønsker du å endre alle dine kommunikasjonsinnstillinger? Da kan du ",
      LOG_IN_HERE: "logge inn her.",
      DO_YOU_HAVE_QUESTIONS: "Har du spørsmål?",
      CONTACT_CUSTOMER_SERVICE_HERE: "Kontakt vår kundeservice her.",
      PHONE_NUMBER: "Telefonnummer",
      EXAMPLE: "Eks: 98765432",
      INVALID_PHONE_NUMBER: "Ugyldig telefonnummer",
      PHONE_NUMBER_REQUIRED: "Vennligst oppgi telefonnummer",
    },
    se: {
      UNSUBSCRIBE_FROM_SMS: "Avregistrera SMS",
      NO_LONGER_INTERESTED: "Inte längre intresserad av SMS?",
      TYPE_IN_YOUR_PHONE_NUMBER: `Vänligen ange det telefonnummer du har registrerat hos ${BRAND_NAME_FULL} för att avregistrera dig från framtida SMS-utskick.`,
      CONFIRM_UNSUBSCRIPTION: "Bekräfta avregistrering",
      YOU_ARE_NOW_UNSUBSCRIBED:
        "Du är nu avregistrerad från SMS. Observera att det kan ta ett par dagar innan ändringen träder i kraft.",
      YOU_WILL_STILL_RECEIVE_SMS_ABOUT_DELIVERIES:
        "Du kommer fortfarande att få SMS med information om pågående leveranser eller kommande ordergenerering. För att hantera alla dina kommunikationsinställningar, ",
      LOG_IN_HERE: "logga in här.",
      DO_YOU_HAVE_QUESTIONS: "Frågor?",
      CONTACT_CUSTOMER_SERVICE_HERE: "Kontakta oss här.",
      PHONE_NUMBER: "Telefonnummer",
      EXAMPLE: "Exempel: 0701234567",
      INVALID_PHONE_NUMBER: "Ogiltigt telefonnummer",
      PHONE_NUMBER_REQUIRED: "Vänligen ange telefonnummer",
    },
    dk: {
      UNSUBSCRIBE_FROM_SMS: "Afmeld SMS",
      NO_LONGER_INTERESTED: "Vil du ikke længere modtage SMS'er fra os?",
      TYPE_IN_YOUR_PHONE_NUMBER: `Indtast det telefonnummer, du er registreret med hos ${BRAND_NAME_FULL}, så fjerner vi dig fra fremtidige SMS-udsendelser.`,
      CONFIRM_UNSUBSCRIPTION: "Afmeld",
      YOU_ARE_NOW_UNSUBSCRIBED:
        "Du er nu afmeldt SMS. Bemærk, at det kan tage et par dage før ændringen træder i kraft.",
      YOU_WILL_STILL_RECEIVE_SMS_ABOUT_DELIVERIES:
        "Du vil fortsat modtage SMS’er med leveringsinformation og påmindelser i forbindelse med din levering. Ønsker du at ændre alle dine kontaktindstillinger? ",
      LOG_IN_HERE: "Log ind her.",
      DO_YOU_HAVE_QUESTIONS: "Har du spørsmål?",
      CONTACT_CUSTOMER_SERVICE_HERE: "Kontakt vores kundeservice her.",
      PHONE_NUMBER: "Telefonnummer",
      EXAMPLE: "Eks: 98765432",
      INVALID_PHONE_NUMBER: "Ugyldigt telefonnummer",
      PHONE_NUMBER_REQUIRED: "Vennligst oppgi telefonnummer",
    },
  } as const
)[language];
